var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.agent)?_c(_vm.agent_name,{tag:"component",attrs:{"agent":_vm.agent}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }